import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-stall-form',
  templateUrl: './stall-form.component.html',
  styleUrls: ['./stall-form.component.scss'],
  standalone: false
})
export class StallFormComponent implements OnInit {

  form!: FormGroup;
  so_id!: number;
  productList: any;
  mem_id: any;

  constructor(
    private fb: FormBuilder,
    private service: ServicesService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {

    this.so_id = this.route.snapshot.params['so_id'];
    this.mem_id = this.route.snapshot.params['mem_id'];

    console.log(this.mem_id);



    this.getProducts();

    this.form = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      interests: this.fb.array([], Validators.required),
      other: [''],
      mem_id: this.mem_id,
      so_id: this.so_id
    });
  }

  getProducts() {
    this.service.getProductsForStall(this.so_id).subscribe(
      (data: any) => {
        console.log(data);
        this.productList = data.data
      }
    );
  }

  get interests(): FormArray {
    return this.form.get('interests') as FormArray;
  }

  onCheckboxChange(event: any) {
    if (event.target.checked) {
      this.interests.push(this.fb.control(event.target.value));
    } else {
      const index = this.interests.controls.findIndex(
        x => x.value === event.target.value
      );
      this.interests.removeAt(index);
    }
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    console.log(this.form.value);

    this.service.add_stall_scan(this.form.value)
      .subscribe((res: any) => {
        if (res.flag == true) {
          // this.toastr.success(res.msg);
          window.location.reload();
        } else if (res.flag == false) {
          // this.toastr.error(res.msg);
        }
      });
  }
}
